import React from 'react';
import { useTranslation } from 'react-i18next';
import { WavingHand } from '@mui/icons-material';
import { Fade } from '@mui/material';
import { useInstallationContext } from '../../../../../../context/installation';
import { useUserProfileStore } from '../../../../../../store/user-profile';
import {
  GreetingsBannerContainer,
  GreetingsBannerPattern,
  GreetingsBannerGreeting,
  GreetingsBannerSubtitle,
} from './greetings.styled';

export const DashboardGreetingsBanner: React.FC = () => {
  const { t } = useTranslation('dashboard');
  const { selectedInstallation } = useInstallationContext();
  const { firstName } = useUserProfileStore((s) => s.meData);

  const installationName = selectedInstallation?.name;

  return (
    <Fade in timeout={800}>
      <GreetingsBannerContainer>
        <GreetingsBannerPattern />
        <GreetingsBannerGreeting>
          {`${t('welcomeBanner.header')}${firstName ? `, ${firstName}!` : '!'}`}
          <WavingHand sx={{ fontSize: 'inherit' }} />
        </GreetingsBannerGreeting>

        <GreetingsBannerSubtitle>{t('welcomeBanner.message', { installationName })}</GreetingsBannerSubtitle>
      </GreetingsBannerContainer>
    </Fade>
  );
};
